export default "__VITE_ASSET__C$Umiopo__"